module.exports = __webpack_public_path__ + "static/media/PST01@s.d12779e8.jpg";